import { render, staticRenderFns } from "./UMDetail.vue?vue&type=template&id=8f1ad74c"
import script from "./UMDetail.vue?vue&type=script&lang=js"
export * from "./UMDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports